module.exports = __webpack_public_path__ + "img/sample_img_intro_03.94ecdf63.png";